/**
 * Adds variables to the data layer (for GTM).
 */
export default () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ env: process.env.APP_ENV });
};
